<category-component></category-component>
<div class="fixed-header-height static-pages-header">
    <h1>About Us</h1>
</div>
<div>
<div class="grey-color static-pages side-space-wrapper static-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <ul class="breadcrumbs d-flex pt-3 pt-md-0">
                    <li>
                        <a routerLink="/" title="Home">Home</a>
                    </li>
                    <li>
                        <span> <img src="../../assets/images/seperator-arrow.svg" alt="seperator-arrow" /> </span>
                    </li>
                    <li>
                        About Us
                    </li>
                </ul>
            </div>
        </div>
        <div *ngFor="let data of firstSection; let i = index; 
        let even = even; let odd = odd">
        <div class="row content-row" *ngIf="even">
            <div class="col-12 col-lg-6 align-items-center d-flex order-2 order-lg-0">
                <div class="description">
                    <h2>{{data.heading}}</h2>
                    <p>{{data.description}}</p>
                </div>
            </div>
            <div class="col-12 col-lg-6" *ngIf="data.image != null">
                <div class="featured-image">
                    <img [src]="statePersist.getSafeUrl(data.image.url)" alt="product image">
                </div>
            </div>
        </div>
        <div class="row content-row mb-0" *ngIf="odd">
            <div class="col-12 col-lg-6" *ngIf="data.image != null">
                <div class="featured-image">
                    <img [src]="statePersist.getSafeUrl(data.image.url)" alt="product image">
                </div>
            </div>
            <div class="col-12 col-lg-6 align-items-center d-flex second">
                <div class="description">
                    <h2>{{data.heading}}</h2>
                    <p>{{data.description}}</p>
                </div>
            </div>
        </div>
        </div>
    </div>
</div>
<div class="blue-bg side-space-wrapper static-content">
    <div class="container-fluid">
        <div class="row" *ngFor="let data of secondSection; let i = index;">
            <div class="col-12">
                <h3>{{data.heading}}</h3>
                <p></p>
            </div>
            <div class="col-12 col-md-6">
                <p>{{data.description1}}</p>
            </div>
            <div class="col-12 col-md-6">
                <p>{{data.description2}}</p>
            </div>
        </div>
    </div>
</div>
</div>
<div class="grey-bg pt-0">
    <testimonial-slider></testimonial-slider>
</div>
<download-app></download-app>